export const ITEM_INDEX = 'item';
export const QTI_CONTEXT_INDEX = 'QTI_CONTEXT';
export const RESOURCE = 'RESOURCE';
export const USER_INDEX = 'user';
export const VERSION_INDEX = 'content_version';
export enum AuthorFilterTypes {
    SECTION = 'AUTHOR_FILTER_SECTION',
    QUESTION = 'AUTHOR_FILTER_QUESTION'
}
